/**
 * One H1 per page.
 *
 * Editors pick heading levels per section in Prismic, which gave some pages
 * five H1s and others none. Exactly one slice per page owns the H1:
 *   1. the first slice with a Heading 1, or
 *   2. if the page has no Heading 1, the first slice with a Heading 2.
 * That slice renders its title as <h1>; every other slice renders its title
 * as <h2> with the same styling.
 *
 * Slices receive `index` and `slices` from <SliceZone>.
 */

const hasHeading = (slice, type) =>
  JSON.stringify(slice?.primary ?? {}).includes(`"type":"${type}"`)

const titleOwnerIndex = (slices = []) => {
  const h1 = slices.findIndex(s => hasHeading(s, "heading1"))
  return h1 !== -1 ? h1 : slices.findIndex(s => hasHeading(s, "heading2"))
}

/** "h1" if this slice owns the page title, otherwise "h2". */
export const titleTag = (slices = [], index = 0) =>
  titleOwnerIndex(slices) === index ? "h1" : "h2"
